<template>
  <v-card class="mb-2 event-logs">
    <v-card-title>
      <div class="d-flex align-center">
        <v-btn elevation="1" class="mr-3" fab small @click="TOGGLE_CLOSED_BLOCK('log_events')" color="white">
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
        <h2>Лог событий</h2>
      </div>
    </v-card-title>
    <div v-if="isShow">
      <v-expansion-panels accordion>
        <v-data-table
          class="flex-grow-1"
          :options.sync="options"
          :headers="headers"
          :items="log"
          :loading="loading"
          :server-items-length="meta.total"
        >
          <template v-slot:item.log="{ item }">
            <v-expansion-panel :key="$date(item.created_at).format('DD.MM.YYYY HH:mm')">
              <v-expansion-panel-header>
                <div>
                  <strong>{{ $date(item.created_at).format("DD.MM.YYYY HH:mm") }}</strong> {{ item.message }}<br />
                  Доктор: {{ item.doctor_name }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <ul v-if="item.type === 'allergy'">
                  <li>Аллерген: {{ item.data.allergens.map(i => i.name).join(", ") }}</li>
                  <li>Где проявляется: {{ item.data.areas.map(i => i.translation.allergy_area_name).join(", ") }}</li>
                  <li>Реакция: {{ item.data.reactions.map(i => i.translation.allergy_reaction_name).join(", ") }}</li>
                  <li>Степень: {{ item.data.degree.translation.allergy_degree_name }}</li>
                </ul>
                <ul v-if="item.type === 'customer'">
                  <div>
                    <img
                      v-if="item.data.avatar"
                      :src="item.data.avatar"
                      class="med-card__avatar"
                      width="80"
                      style="object-fit: cover;"
                    />
                    <img v-else src="@/assets/img/avatar5.png" width="80" class="med-card__avatar" />
                  </div>

                  <li>Имя: {{ item.data.name }}</li>
                  <li>Фамилия: {{ item.data.surname }}</li>
                  <li>Отчество: {{ item.data.patronymic }}</li>
                  <li>Телефон: {{ item.data.phone }}</li>
                  <li>Дата рождения: {{ $date(item.data.birthdate).format("DD MMMM YYYY") }}</li>
                  <li>Пол: {{ item.data.sex === 1 ? "Женский" : "Мужской" }}</li>
                  <li>Номер паспорта: {{ item.data.passport_number }}</li>
                  <li>Серия паспорта: {{ item.data.passport_series }}</li>
                  <li>Прочие паспортные данные: {{ item.data.passport_data }}</li>
                  <li>Номер страховки: {{ item.data.dms }}</li>
                  <li>Пароль: {{ item.data.password }}</li>
                  <li>Организация: {{ getValueById("organization", item.data.organization_id) }}</li>
                  <li>Отдел: {{ getValueById("structure", item.data.structure_id, item.data.organization_id) }}</li>
                  <li>Должность: {{ getValueById("position", item.data.position_id) }}</li>
                  <li>Cтраховая компания: {{ getValueById("insurance", item.data.insurance_company_id) }}</li>
                </ul>

                <div class="pa-4 mt-1" style="background: #fafafa;">
                  <details>
                    <summary>Необработанные данные</summary>

                    <pre class="text-body-2" style="font-family: monospace !important;">{{ item.data }}</pre>
                  </details>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-data-table>
      </v-expansion-panels>
    </div>
  </v-card>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { QueryHelper } from "@/services/query-helper";
export default {
  name: "LogEvents",
  data: () => ({
    loading: false,
    headers: [{ text: "", value: "log", sortable: false }],
    options: {},
    meta: {
      total: 0,
    },
    log: [],
    orgList: [],
    positionsList: [],
    insuranceList: [],
    misOrgs: [],
  }),
  computed: {
    ...mapState("ikp", ["closedBlocks"]),
    isShow() {
      return !this.closedBlocks.includes("log_events");
    },
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("ikp", ["TOGGLE_CLOSED_BLOCK"]),
    getValueById(type, id, parent_id) {
      if (type === "organization") {
        const org = this.orgList.find(el => el.organization_id === id);
        return org?.organization_fullname || id;
      }
      if (type === "structure") {
        const org = this.orgList.find(el => el.organization_id === parent_id);
        if (org && org.structures) {
          const str = org.structures.find(el => el.id === id);
          if (str) {
            return str.fullname || id;
          }
        }
        return id;
      }

      if (type === "position") {
        const pos = this.positionsList.find(el => el.id === id);
        return pos?.name || id;
      }

      if (type === "insurance") {
        const ins = this.insuranceList.find(el => el.id === id);
        return ins?.name || id;
      }
    },
    async load() {
      this.loading = true;
      try {
        const [orgs, positions, misOrgs, insurance, logs] = await Promise.all([
          this.$http.get(`/v1/organizations`, { params: { lang: "ru" } }),
          this.$http.get(`/v1/organizations/positions`, { params: { lang: "ru" } }),
          this.$http.get(`/v1/clinics`, { params: { lang: "ru" } }),
          this.$http.get(`/v1/insurance/companies`, { params: { lang: "ru" } }),
          this.$http.get(`v1/customers/${this.customerId}/event-logs`, {
            params: { ...QueryHelper.pagination(this.options, this.meta.total) },
          }),
        ]);
        if (orgs.data.success) {
          this.orgList.push(...orgs.data.data);
        }
        if (positions.data) {
          this.positionsList.push(...positions.data.data);
        }
        if (insurance.data) {
          this.insuranceList.push(...insurance.data.data);
        }
        if (misOrgs.data) {
          this.misOrgs.push(...misOrgs.data.data);
        }
        if (logs.data) {
          this.meta.total = logs.data.meta.total;
          this.log = logs.data.data;
        }
      } catch (err) {
        console.error(`ошибка загрузки лога событий =>`, err);
        this.$notify.showMessage("Ошибка загрузки лога событий", "error");
      }

      this.loading = false;
    },
  },
  created() {
    this.load();
  },
};
</script>

<style>
.event-logs .v-data-table-header {
  display: none;
}
html .event-logs .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 0 !important;
}
</style>
